<template>
		<div id="pageRoot">
	
			<label class="toggleButtonContainer pageElement" id="toggle01">PEREJIL
				<input type="radio"
				name="pelota"
				ref="1-1" 
				v-on:change="saveOption('radios', 1, 1)" 
				:onload="loadOption('radios', 1, 1)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle02">PELO
				<input type="radio"
				name="pelota"
				ref="1-2" 
				v-on:change="saveOption('radios', 1, 2)" 
				:onload="loadOption('radios', 1, 2)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle03">PELOTA
				<input type="radio"
				name="pelota"
				ref="1-3" 
				v-on:change="saveOption('radios', 1, 3)" 
				:onload="loadOption('radios', 1, 3)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle04">PERA
				<input type="radio"
				name="pelota"
				ref="1-4" 
				v-on:change="saveOption('radios', 1, 4)" 
				:onload="loadOption('radios', 1, 4)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle05">ALGODÓN
				<input type="radio"
				name="almohadon"
				ref="2-1" 
				v-on:change="saveOption('radios', 2, 1)" 
				:onload="loadOption('radios', 2, 1)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle06">ALMOHADÓN
				<input type="radio"
				name="almohadon"
				ref="2-2" 
				v-on:change="saveOption('radios', 2, 2)" 
				:onload="loadOption('radios', 2, 2)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle07">ALFOMBRA
				<input type="radio"
				name="almohadon"
				ref="2-3" 
				v-on:change="saveOption('radios', 2, 3)" 
				:onload="loadOption('radios', 2, 3)">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle08">ALMANAQUE
				<input type="radio"
				name="almohadon"
				ref="2-4" 
				v-on:change="saveOption('radios', 2, 4)" 
				:onload="loadOption('radios', 2, 4)">
				<span class="toggleButton"></span>
			</label>

			<div id="ball" class="basicItem01">
				<img src="/pages/img/sordo/svgPage65Ball.svg" class="pageElement" style=" width: 100%; height: auto;">
			</div>
			<div id="cushion" class="basicItem01">
				<img src="/pages/img/sordo/svgPage65Cushion.svg" class="pageElement" style=" width: 100%; height: auto;">
			</div>

			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
			<span class="footer-page footer-read"></span>
			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		</div>
</template>
<style scoped>
#toggle01{
/* Ellipse 3 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 328px;
top: 97.86px;
z-index: 3;
}
#toggle02{
/* Ellipse 3 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 328px;
top: 151.95px;
z-index: 3;

}
#toggle03{/* Ellipse 3 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 328px;
top: 205.09px;
z-index: 3;
}
#toggle04{
/* Ellipse 3 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 328px;
top: 259.18px;
z-index: 3;
}
#toggle05{
/* Ellipse 4 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 328px;
top: 400.86px;
z-index: 3;

}
#toggle06{/* Ellipse 5 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 328px;
top: 454.95px;
z-index: 3;
}
#toggle07{
/* Ellipse 6 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 328px;
top: 508.09px;
z-index: 3;
}
#toggle08{
/* Ellipse 7 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 328px;
top: 562.18px;
z-index: 3;
}

#ball
{
	position: absolute;
	left: 12.11%;
	right: 74.74%;
	top: 17.97%;
	bottom: 65.23%;
}
#cushion 
{
	position: absolute;
	left: 8.5%;
	right: 72.58%;
	top: 52.86%;
	bottom: 22.81%;
}
</style>
<script>
  export default {
	data() {
		return {
			videos: ["p63-65/V41.mp4", "p63-65/V42.mp4"],
		};
	},
    methods:{
      dbId(name, group){
        return `${this.$parent.pageID()}-${name}-${group}`
      },
      async loadOption(name, group, option) {
        var id = this.dbId(name, group);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[group+"-"+option].checked=value.option==option;

        console.log("option loaded: " + id + ", option:" + option + ", selected:" + value.option);
      },
      saveOption(name, group, option) {
        var id = this.dbId(name, group);

        this.$db.options.put({
              id: id,
              option: option
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + option);
      }
    }
  }
</script>